import React from 'react';
const Notify = (props) => {
    const {count} = props;
    if(count != '0') {
    return (
            <>
                <div className="counter" >{count}</div>
            </>
    )
    }
    else{
        return (
            <>
          </>
      )
    }
};

export default Notify;
